var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.143 3.402a2.918 2.918 0 0 0-2.057-2.056C19.272.859 12.001.859 12.001.859s-7.273 0-9.085.487A2.918 2.918 0 0 0 .859 3.402C.373 5.217.373 9 .373 9s0 3.785.486 5.597a2.914 2.914 0 0 0 2.057 2.056C4.73 17.14 12 17.14 12 17.14s7.273 0 9.085-.487a2.918 2.918 0 0 0 2.057-2.056c.486-1.815.486-5.597.486-5.597s0-3.785-.486-5.597ZM9.675 12.487V5.511l6.042 3.488-6.042 3.488Z",
  fill: "currentColor"
})));

export default SvgIconYoutube;